<template>
  <div>
    <el-alert
      title="上班创建进行中记录，下班按当前时间计算实际秒数。同一员工同时只能有一条进行中打卡。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-select v-model="clockForm.staffId" filterable clearable placeholder="员工" style="width:200px">
        <el-option
          v-for="item in staffOptions"
          :key="item.staffId"
          :label="(item.staffNumber || '') + ' / ' + (item.staffName || '')"
          :value="item.staffId"
        />
      </el-select>
      <el-select v-model="clockForm.orderId" filterable clearable placeholder="工单（可选）" style="width:220px" @change="onOrderChange">
        <el-option
          v-for="item in orderOptions"
          :key="item.orderId"
          :label="(item.orderCode || '') + ' / ' + (item.orderName || '')"
          :value="item.orderId"
        />
      </el-select>
      <el-select v-model="clockForm.taskId" filterable clearable placeholder="工序任务（可选）" style="width:220px" :disabled="!clockForm.orderId" @change="onTaskChange">
        <el-option
          v-for="item in taskOptions"
          :key="item.taskId"
          :label="(item.taskCode || '') + ' / ' + (item.operationName || '')"
          :value="item.taskId"
        />
      </el-select>
      <el-button type="success" :loading="clockLoading" @click="doClockIn">上班打卡</el-button>
    </div>

    <div class="toolbar">
      <el-input v-model="query.workTimeCode" clearable placeholder="单号" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.staffId" filterable clearable placeholder="员工" style="width:160px">
        <el-option v-for="item in staffOptions" :key="item.staffId" :label="item.staffName" :value="item.staffId" />
      </el-select>
      <el-select v-model="query.workState" clearable placeholder="状态" style="width:110px">
        <el-option label="进行中" value="00" />
        <el-option label="已结束" value="01" />
      </el-select>
      <el-date-picker v-model="query.dateFrom" type="date" value-format="yyyy-MM-dd" placeholder="日期从" style="width:140px" />
      <el-date-picker v-model="query.dateTo" type="date" value-format="yyyy-MM-dd" placeholder="到" style="width:140px" />
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
    </div>

    <el-table :data="list" border v-loading="loading">
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="workTimeCode" label="打卡单号" width="180" />
      <el-table-column prop="staffNumber" label="员工编码" width="110" />
      <el-table-column prop="staffName" label="员工" width="110" />
      <el-table-column prop="orderCode" label="工单" width="140" />
      <el-table-column prop="operationName" label="工序" width="120" show-overflow-tooltip />
      <el-table-column prop="timeStart" label="开始" width="170" />
      <el-table-column prop="timeEnd" label="结束" width="170" />
      <el-table-column label="实际工时" width="120" align="right">
        <template slot-scope="{ row }">{{ formatHours(row.laborSeconds) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.workState === '00' ? 'warning' : 'success'">{{ row.workState === '00' ? '进行中' : '已结束' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" :disabled="row.workState !== '00'" @click="doClockOut(row)">下班打卡</el-button>
          <el-button type="text" style="color:#ef4444" :disabled="row.workState !== '00'" @click="doDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage" @size-change="onSize"
    />
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listStaffWorkTime, clockIn, clockOut, deleteStaffWorkTime } from '../../api/staffWorkTime'
import { selectStaff } from '../../api/staff'
import { selectProductionOrder } from '../../api/productionOrder'
import { selectOrderTask } from '../../api/orderTask'

export default {
  name: 'StaffClockPage',
  components: { ListPagination },
  data() {
    return {
      clockForm: { staffId: '', orderId: '', taskId: '', operationId: '' },
      clockLoading: false,
      query: { workTimeCode: '', staffId: '', workState: '', dateFrom: '', dateTo: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      staffOptions: [], orderOptions: [], taskOptions: []
    }
  },
  created() {
    selectStaff().then(res => { this.staffOptions = res.data || [] }).catch(() => {})
    selectProductionOrder().then(res => { this.orderOptions = res.data || [] }).catch(() => {})
    this.load()
  },
  methods: {
    indexMethod(i) { return (this.page - 1) * this.pageSize + i + 1 },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    onOrderChange() {
      this.clockForm.taskId = ''
      this.clockForm.operationId = ''
      this.taskOptions = []
      if (!this.clockForm.orderId) return
      selectOrderTask(this.clockForm.orderId).then(res => { this.taskOptions = res.data || [] }).catch(() => { this.taskOptions = [] })
    },
    onTaskChange(taskId) {
      const task = this.taskOptions.find(x => x.taskId === taskId)
      this.clockForm.operationId = task ? task.operationId : ''
    },
    load() {
      this.loading = true
      listStaffWorkTime({
        currentPage: this.page, pageSize: this.pageSize, ...this.query
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    doClockIn() {
      if (!this.clockForm.staffId) {
        this.$message.warning('请选择员工')
        return
      }
      this.clockLoading = true
      clockIn(this.clockForm).then(res => {
        const code = (res.data || {}).workTimeCode || ''
        this.$message.success('上班打卡成功 ' + code)
        this.load()
      }).finally(() => { this.clockLoading = false })
    },
    doClockOut(row) {
      this.$confirm('确认下班打卡？将按当前时间计算实际工时。', '提示', { type: 'warning' }).then(() => {
        clockOut({ workTimeId: row.workTimeId }).then(res => {
          this.$message.success('下班打卡成功，工时 ' + this.formatHours((res.data || {}).laborSeconds))
          this.load()
        })
      }).catch(() => {})
    },
    doDelete(row) {
      this.$confirm('确定删除该进行中打卡？', '提示', { type: 'warning' }).then(() => {
        deleteStaffWorkTime([row.workTimeId]).then(() => {
          this.$message.success('已删除')
          this.load()
        })
      }).catch(() => {})
    },
    formatHours(sec) {
      const s = Number(sec) || 0
      const h = Math.floor(s / 3600)
      const m = Math.floor((s % 3600) / 60)
      const r = s % 60
      return h + 'h ' + m + 'm ' + r + 's'
    }
  }
}
</script>
